import { createRoute, useNavigate } from '@tanstack/react-router';
import { useEffect } from 'react';

import { signInRoute } from './signin';

const HomePage = () => {
  const navigate = useNavigate({ from: '/' });

  useEffect(() => {
    navigate({
      to: '/organizations',
    });
  }, [navigate]);

  return null;
};

export const homeRoute = createRoute({
  getParentRoute: () => signInRoute,
  path: '/home',
  component: HomePage,
});
